import ManageSavedPeerGroups from "../components/PeerGroup/ManageSavedPeerGroups";
import { connect } from "react-redux";
import { All, KeyValue } from "../interfaces";
import { Dispatch } from "redux";
import * as actions from "../common/actions";

export function mapStateToProps({ appState }: All) {
  return {
    appState: (appState as KeyValue)[appState.app],
    banner: appState.banner,
  };
}
function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    setSavedReportId: (id: string) => {
      dispatch(actions.updateUi("savedReportId", id));
    },
    updateTab: (tabName: string) => {
      dispatch(actions.updateUi("tab", tabName));
      dispatch(actions.searchPush());
    },
    updateUi: (name: string, value: any) => {
      dispatch(actions.updateUi(name, value));
    },
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ManageSavedPeerGroups);
